<template>
  <div>
    <v-card
      color="white"
      min-height="500px"
      style="min-height:500px">
      <div class="form-container">
        <!-- <h2>Шаг 6. Сохранение данных</h2> -->
        <div class="input-container">
            <SaveButton
            @switchDialog="dialog = !dialog"
            @result="snackbar = !snackbar, color = $event.color, type = $event.type"
            :styles="styleObj" />
        </div>
      </div>
    </v-card>
  
    <v-dialog
      :persistent="true"
      v-model="dialog"
      width="600">
      <v-card>
        <v-card-title
          class=""
          primary-title>
          {{$t('formedProposal')}}
        </v-card-title>
        <v-card-text>
          {{ type ? this.$t('Step6.success') : this.$t('Step6.error') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="close_modal()">
              {{$t('ok')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import SaveButton from '../Common/SaveButton.vue';

export default {
  name: 'SelectionAdditionalEquipment',
  components: {
    SaveButton,
  },

  data() {
    return {
      styleObj: 'btn-save',
      snackbar: false,
      timeout: 3000,
      color: 'grey',
      dialog: false,
      type: ''
    };
  },
  
  methods: {
    close_modal() {
      this.dialog = false
      this.$router.push('/user')
    }
  },
  watch: {
    snackbar() {
      if (this.type) {
        this.$messageHelper(this.$t('success'), 'success')
      } else {
        this.$messageHelper(this.$t('success'), 'error')
      }
    }
  }
};
</script>
<style scoped>
  .input-container {
    display: flex;
    flex-direction: column;
    margin-top: 15px;
    width: 100%;
  }
  .btn-save-completed{
    background: rgb(40, 153, 79);
    border-radius: 15px 15px 0 0;
    color:white;
    padding: 15px 20px;
  }


  .form-container {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    width: 100%;
  }
  .mb-12.wrapper.v-card.v-sheet.theme--light.white{
    box-shadow: none;
  }
  h4{
    color: #949494;
    letter-spacing: -0.015em;
    font-style: normal;
    font-weight: 500;
  }
</style>
